import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DigitalAssetSelectors from '../../../../modules/domain/digitalAsset/selectors'
import { useAction } from '@agro-club/frontend-shared'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import { useCompanyList } from '../../../../modules/domain/company/hooks'
import { DigitalAssetListRequestFilter } from '../../../../modules/domain/digitalAsset/types'
import { CompanyListRequestFilter } from '../../../../modules/domain/company/types'
import { SelectProps } from 'antd'
import CompanyActions from '../../../../modules/domain/company/duck'
import CompanySelectors from '../../../../modules/domain/company/selectors'
import { useDebouncedCallback } from 'use-debounce'
import GenericSelect from '../../Generics/GenericSelect'
/* Select component for filtering digital assets using the company that created the asset
 *
 * */
const DACompanyFilterSelect: React.FC = () => {
  const { t } = useTranslation('digitalAsset')
  const digitalAssetFilter = useSelector(DigitalAssetSelectors.filter)
  const digitalAssetFilterUpdate = useAction(DigitalAssetActions.filterUpdated)
  let { company_id } = digitalAssetFilter
  const [companyIds, setCompanyIds] = useState<string[]>([])
  const [, dbCompanies] = useCompanyList({})
  const companyFilter = useSelector(CompanySelectors.filter)
  const companyFilterUpdate = useAction(CompanyActions.filterUpdated)
  const [companySelectItems, setCompanySelectItems] = useState<SelectProps['options']>([])

  useEffect(() => {
    if (dbCompanies) {
      setCompanySelectItems(
        dbCompanies.map((company) => ({
          value: company.id,
          label: company.official_name,
        })),
      )
    }
  }, [dbCompanies, companyFilter, companyFilterUpdate])

  const addToDigitalAssetFilter = (companyIds: string[]) => {
    setCompanyIds(() => [...companyIds])
  }

  const handleDigitalAssetFilterChange = useCallback(
    (newFilterValue: Partial<DigitalAssetListRequestFilter>) => {
      digitalAssetFilterUpdate({ ...digitalAssetFilter, ...newFilterValue })
    },
    [digitalAssetFilterUpdate, digitalAssetFilter],
  )

  const executeDigitalAssetFilter = () => {
    company_id = companyIds
    handleDigitalAssetFilterChange({ company_id })
  }

  const handleCompanyFilterChange = useCallback(
    (newFilterValue: Partial<CompanyListRequestFilter>) => {
      companyFilterUpdate({ ...companyFilter, ...newFilterValue })
    },
    [companyFilterUpdate, companyFilter],
  )

  const debouncedCallback = useDebouncedCallback(
    (value: string) => {
      if (value.length > 3) {
        handleCompanyFilterChange({ search: value })
      }
      if (value.length === 0) {
        handleCompanyFilterChange({ search: undefined })
      }
    },
    300,
    {
      trailing: true,
      maxWait: 400,
    },
  )

  return (
    <GenericSelect
      mode="multiple"
      maxTagCount="responsive"
      filterOption={false}
      placeholder={t('select.uploadedBy')}
      title={t('select.uploadedBy')}
      options={companySelectItems}
      applyButtonLabel={t('button.applyFilter')}
      onApply={executeDigitalAssetFilter}
      onChange={addToDigitalAssetFilter}
      onSearch={debouncedCallback}
      parentContainerFlex={1}
    />
  )
}

export default DACompanyFilterSelect
